import { useCallback } from "react";
import bondSecuritiesStore from "@/store/bondSecuritiesStore";
import { searchBondSecurities } from "@/store/bondSecuritiesStoreACTIONS";
import { returnReferenceDataOptions } from "./ticketSharedHelper";

// ISIN and name searches over GET /Securities/bonds, shared by the bond and bond option
// tickets. Both commit the ISIN - they are two views of one choice.
export function useBondSecuritySearch() {
  // A new identity when the securities land, so an open typeahead refreshes.
  const bondSecurities = bondSecuritiesStore((state) => state.bondSecurities);

  const searchIsinOptions = useCallback(
    (term: string, limit: number) =>
      returnReferenceDataOptions(searchBondSecurities(term, limit), (bond) => ({
        label: bond.isin,
        value: bond.isin,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bondSecurities],
  );

  const searchSecurityNameOptions = useCallback(
    (term: string, limit: number) =>
      returnReferenceDataOptions(searchBondSecurities(term, limit), (bond) => ({
        label: bond.securityName,
        value: bond.isin,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bondSecurities],
  );

  return { searchIsinOptions, searchSecurityNameOptions };
}
